import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { SideMenu } from '../../components/reusable/routing.js'

import { useReports, useLatestPathname } from '../../modules.js'

import SonographyQueue from './Queue.js'

let menu = [
    {
        path: 'queue',
        title: 'Queue',
        component: SonographyQueue
    }
]

const Sonography = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Reports, reports] = useReports("sonography")

    useEffect(() => {
        menu[1] = {
            path: 'reports',
            title: 'Reports',
            component: () => <Reports reports={ reports } department="sonography" />
        }

        const target = `/app/sonography/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Sonography</p>
                <SideMenu namespace="sonography" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="sonography" menu={ menu } />
            </div>
        </div>
    )
}

export default Sonography